import { useQuery } from '@tanstack/react-query'

import { getPointsOfInterestByBuilding } from '@/ports'

const fetchPoi = (buildingId: string) => {
  return getPointsOfInterestByBuilding(
    {
      body: {}
    },
    { buildingId }
  ).then(res => res.body as any)
}

export const useGetPoints = (buildingId: string) => {
  const { data, isLoading } = useQuery({
    queryKey: ['poi', buildingId],
    queryFn: () => fetchPoi(buildingId),
    enabled: !!buildingId,
    staleTime: 3 * 1000000000,
    refetchOnWindowFocus: false
  })

  return { data, isLoading }
}
